module.exports = __webpack_public_path__ + "static/media/ver.fc97e6e4.svg";